const initialState = {
    data: {
        size: 0,
        totalElements: 0,
        totalPages: 0,
        currentPage: 0,
        data: []
    },
    isLoading: true,
    hasErrored: false,
};

export default (state = initialState, action) => {
    switch (action.type) {
        case '[RH] HAS_ERRORED':
            return {...state, isLoading: false, data: initialState.data, hasErrored: true};
        case '[RH] IS_LOADING':
            return {...state, hasErrored: false, data: initialState.data, isLoading: true};
        case '[RH] FETCH_SUCCESS':
            return {...state, hasErrored: false, isLoading: false, data: action.data};
        default:
            return state;
    }
};
